import type { CSSProperties } from 'react';
import { Text } from '@wapharma/design-system';
import { SUPPORT_TICKET_TYPE_FILTER_PILLS } from '../constants/supportTicketFilterPills';
import type { FilterPillDef } from './filters/FilterPillGroup';

function isPalettePill(
  pill: FilterPillDef,
): pill is FilterPillDef & { accent: string; bg: string; border: string } {
  return 'accent' in pill && 'bg' in pill && 'border' in pill;
}

export function supportTicketTypePillMeta(type: string) {
  return SUPPORT_TICKET_TYPE_FILTER_PILLS.find((o) => o.value === type) ?? null;
}

const PILL_STYLE: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  borderRadius: 999,
  padding: '3px 8px',
  lineHeight: 1,
};

export function SupportTicketTypePill({ type }: { type: string }) {
  const pill = supportTicketTypePillMeta(type);
  if (!pill?.value || !isPalettePill(pill)) {
    return (
      <Text size="xs" fw={600}>
        {type}
      </Text>
    );
  }

  const Icon = pill.icon;
  return (
    <Text
      size="xs"
      fw={600}
      style={{
        ...PILL_STYLE,
        color: pill.accent,
        background: pill.bg,
        border: `1px solid ${pill.border}`,
      }}
    >
      <Icon size={14} stroke={1.8} aria-hidden />
      {pill.label}
    </Text>
  );
}
